import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import AddExternalLink from './AddExternalLink';
import { withRouter } from "react-router-dom";
import externalLinkBg from 'Assets/images/externalLinkBg.png';
import { getCurrentLangIndex, setDefaultTitle } from "Pub/js/getMulti";
import Ajax from 'Pub/js/ajax';
import { langCheck } from "Pub/js/utils.js";
import externalLinkIcon from 'Pub/js/externalLinkIcon';
import { setExternalLinks } from "Store/GridLayout/action";
import Notice from "Components/Notice";
import './index.less';
import { addExternalLink, getAjaxNewData, editExternalLink, urlTest, getImageKey } from './common';
import platform from "Pub/js/platform";
const { PubSub, } = platform;

let ExternalLinks = (props) => {
    let {
        isDefaultStyle = true,
        id,
        editable = false,
        defaultName = langCheck('0000PUB-000387'), // 常用链接 多语
        onAddWidgetComplete,
        isSaveComplete,
        setExternalLinks, //redux 保存
        saveExternalLinkData, //redux 常用链接数据
        orderType, // 常用应用的样式
    } = props;
    const newDefaultName = setDefaultTitle('title', defaultName);
    const obj = {
        appcode: '10182004',
        cardid: new Date().getTime(),
        chosen: false,
        gridX: 667,
        gridY: 999,
        height: 1,
        isChecked: false,
        isShadow: false,
        title: '',
        title2: '',
        title3: '',
        selected: false,
        width: 1,
        url: '',
        image: 'externallinkicon1',
    }
    const [showAddLink, setShowAddLink] = useState(false);
    // console.log(saveExternalLinkData)
    let externalLinkData = {};
    if (JSON.stringify(saveExternalLinkData) != '{}') {
        if (saveExternalLinkData.hasOwnProperty(id)) {
            externalLinkData = saveExternalLinkData[id]
        } else {
            externalLinkData = obj
        }
    } else {
        externalLinkData = obj
    }
    // const [externalLinkData, setExternalLinkData] = useState(saveObj);
    useEffect(() => {
        if (editable) {
            //编辑态自定义按钮区域
            props.renderEditCustomArea && props.renderEditCustomArea(renderAddBtn());
        }
    }, [editable, externalLinkData[`title${getCurrentLangIndex()}`]]);
    // 查询数据 
    const queryExternalLink = () => {
        const data = { pk_group_app: id }
        const newData = getAjaxNewData(props, data);
        return new Promise((resolve) => {
            // 查询接口
            Ajax({
                url: `/nccloud/platform/appregister/queryexternallink.do`,
                info: {
                    name: langCheck('0000PUB-000387'),// 国际化处理： 常用链接,
                    action: langCheck("0000PUB-000127") // 国际化处理： 查询
                },
                // loading: true,
                data: newData,
                success: ({ data: { data, success } }) => {
                    if (success && data) {
                        resolve(data);
                    }
                }
            });
        })
    }
    // 新增默认外部链接  只有标题
    useEffect(() => {
        //只有从桌面编辑态新增外部链接才执行
        if (props.isAddComplete && id && id.indexOf('_new') != -1) {
            let data = { image: 'externallinkicon1', ...newDefaultName };
            addExternalLink(props, data).then((obj) => {
                onAddWidgetComplete && onAddWidgetComplete(obj);
                setExternalLinks(obj);  //存redux 数据
            });
        }
        // // 浏览态请求数据
        // if (!editable) {
        //     queryExternalLink().then((obj) => {
        //         setExternalLinks(obj);  //存redux 数据
        //     })
        // }
        // //监听首页加载完成 为了只查询一次数据
        // const pubsub = PubSub.subscribe("onChangeDesktopEditable", (isEdit) => {
        //     isEdit && queryExternalLink().then((obj) => {
        //         setExternalLinks(obj);  //存redux 数据
        //     });
        // });

        // 防止切换桌面状态时重复请求数据
        if (JSON.stringify(saveExternalLinkData) != '{}') {
            if (!saveExternalLinkData.hasOwnProperty(id)) {
                queryExternalLink().then((obj) => {
                    setExternalLinks(obj);  //存redux 数据
                });
            }
        } else {
            queryExternalLink().then((obj) => {
                setExternalLinks(obj);  //存redux 数据
            });
        }

        // return () => {
        //     pubsub && PubSub.unsubscribe(pubsub); //移除订阅
        // }
    }, [])

    useEffect(() => {
        //桌面保存成功的回调
        if (editable && isSaveComplete && externalLinkData && externalLinkData[`title${getCurrentLangIndex()}`]) {
            handleEdit();
        }
    }, [editable, isSaveComplete]);

    const handleEdit = () => {
        //这里发保存请求
        const { title, title2, title3, url = "", image, pk_group_app, cardid } = externalLinkData;
        const data = {
            title,
            title2,
            title3,
            urllink: url,
            image: image,
            pk_group_app: pk_group_app || cardid // 弹窗新增加的常用链接，是cardid，没有存储pk_group_app
        }
        editExternalLink(props, data)
    }

    useEffect(() => {
        const pubsub = PubSub.subscribe("SetAppComplete", () => {
            if (!editable) {
                // 浏览态桌面保存之后需要保存一下常用链接，不然数据丢失了
                handleEdit();
            }
        });
        return () => {
            PubSub.unsubscribe(pubsub); //移除订阅
        }
    })

    //获取回调数据 
    const onOk = (obj) => {
        setExternalLinks(obj);  //存redux 数据
    }
    const renderAddBtn = () => {
        const iconType = isDefaultStyle && externalLinkData.url === '' ? ' icon-zengjiazhuomian' : ' icon-bianji';
        return (
            <span className="icon-wrap" onClick={(e) => { handleShowAddLink(e) }}>
                <i className={`iconfont${iconType}`} fieldid='bipp-add-edit' ></i>
            </span>
        )
    }

    //默认dom
    const renderDefaultDiv = () => {
        const image = getImageKey(externalLinkData);
        return <div className="external-content-box" onClick={handleOpenExternalLink}>
            {externalLinkData.url === '' ?
                <div className="title-box1">
                    {renderName()}
                    {
                        !editable && (
                            <span className="icon-wrap" onClick={(e) => { handleShowAddLink(e) }}>
                                <i className='iconfont icon-ncc-sq'></i>
                            </span>
                        )
                    }

                </div>
                : <div className="title-box2">
                    {renderName()}
                    {
                        !editable && (
                            <span className="icon-wrap" onClick={(e) => { handleShowAddLink(e) }}>
                                <i className='iconfont icon-bianji1'></i>
                            </span>
                        )
                    }
                </div>
            }
            {
                externalLinkData.url === '' ?
                    <img src={externalLinkBg} className='external-bg' /> :
                    <img src={externalLinkIcon[image] || image} className='external-img' />
            }
        </div>
    }
    //聚合dom
    const renderAggregateDiv = () => {
        const image = getImageKey(externalLinkData);
        return (
            <div
                className='app-item-box'
                title={externalLinkData[`title${getCurrentLangIndex()}`] || externalLinkData.title}
                style={orderType ? orderType.flex : {}}
            >
                <div className="app-icon-container" onClick={handleOpenExternalLink}>
                    <div className="app-icon-content">
                        <div className="app-img">
                            <img src={externalLinkIcon[image] || image} className='external-img' />
                        </div>
                    </div>
                </div>
                {renderName()}
            </div>
        )
    }
    const renderName = () => {
        const { renderLinkageIcons } = props;
        let title = externalLinkData[`title${getCurrentLangIndex()}`] || externalLinkData.title;
        let titleNew = title;
        return <div className='app-name-container'>
            <div className="app-name" style={orderType ? { ...orderType.appName } : {}}>{titleNew}</div>
            {renderLinkageIcons && renderLinkageIcons()}
        </div>;
    }
    const handleOpenExternalLink = () => {
        const { url } = externalLinkData;
        if (editable) {
            return;
        }
        if (urlTest(url) && !editable) {
            window.open(url, '_blank');
        } else {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000608'), //    "0000PUB-000608": "请先配置常用链接"
            });
        }
    }
    const handleShowAddLink = (e) => {
        e.stopPropagation();
        setShowAddLink(true);
    }
    return (
        <React.Fragment>
            {
                isDefaultStyle ? renderDefaultDiv() : renderAggregateDiv()
            }
            {showAddLink &&
                <AddExternalLink
                    onOk={onOk}
                    setShowAddLink={setShowAddLink}
                    externalLinkData={externalLinkData}
                    {...props}
                />}
        </React.Fragment>
    )
}
ExternalLinks = connect(
    state => ({
        isSaveComplete: state.gridLayoutData.isSaveComplete,
        saveExternalLinkData: state.gridLayoutData.saveExternalLinkData
    }),
    {
        setExternalLinks
    }
)(ExternalLinks);
export default withRouter(ExternalLinks);